import { useState } from "react";
import Api from "../functions/Api";
import { ValidationResponse } from "../functions/validation";

const useControlCaja = ({ handleMuestraSnack }) => {
  const [ejecutaapi] = Api();
  const [iniciaCajaRes, setIniciaCajaRes] = useState([]);
  const [cierreCaja, setCierreCaja] = useState(null);
  const [cajasVencidas, setCajasVencidas] = useState([]);
  const [cajaActual, setCajaActual] = useState(null);
  const [historialCierres, setHistorialCierres] = useState([]); // estado de caja del cajero actual

  const usuario = localStorage.getItem("user");
  const userId = usuario ? JSON.parse(usuario).userId : null;

  const getInicioCaja = formulario => {
    let body = JSON.stringify({
      idCajero: formulario.numeroCajero || userId,
      monto: formulario.MontoInicial || 0
    });
    ejecutaapi("IniciaCaja", body).then(data => {
      let { result, error } = ValidationResponse(data);
      if (error !== "") {
        handleMuestraSnack(error, "error");
      } else if (result[0].error === 1) {
        handleMuestraSnack(result[0].msg, "error");
      } else {
        handleMuestraSnack("Caja abierta correctamente", "success");
        // Refrescar estado
        getEstadoCaja(userId);
      }
    });
  };

  const getEstadoCaja = (idCajero) => {
    let body = JSON.stringify({ idCajero: idCajero || userId });
    ejecutaapi("ValidaCajaAbierta", body).then(data => {
      let { result, error } = ValidationResponse(data);
      if (!error && result && result[0]) {
        setCajaActual(result[0]);
      }
    });
  };

  const getConsultaCajaXDia = (idCajero, fechaConsul) => {
    let body = JSON.stringify({
      idCajero: idCajero || userId,
      fechaConsul: fechaConsul
    });
    ejecutaapi("ConsultaCierreXDia", body).then(data => {
      let { result, error } = ValidationResponse(data);
      if (error !== "") {
        handleMuestraSnack(error, "error");
      } else {
        setIniciaCajaRes(result || []);
      }
    });
  };

  const getGeneraCierreCaja = (idCajero, montoInicio, inserta, montoDeclarado) => {
    let body = JSON.stringify({
      idCajero: idCajero || userId,
      montoInicio: montoInicio,
      inserta: inserta,
      montoDeclarado: montoDeclarado || null
    });
    ejecutaapi("CierreDiario", body).then(data => {
      let { result, error } = ValidationResponse(data);
      if (error !== "") {
        handleMuestraSnack(error, "error");
      } else if (result && result[0]) {
        setCierreCaja(result[0]);
        if (inserta) {
          handleMuestraSnack("Caja cerrada correctamente", "success");
          getEstadoCaja(userId);
        }
      } else {
        setCierreCaja(null);
        handleMuestraSnack("No hay datos de cierre", "warning");
      }
    });
  };

  const getCajasVencidas = () => {
    ejecutaapi("ObtieneCajasVencidas", JSON.stringify({})).then(data => {
      let { result, error } = ValidationResponse(data);
      if (!error) setCajasVencidas(result || []);
    });
  };

  const getHistorialCierres = (fechaIni, fechaFin, idCajero) => {
    ejecutaapi("ObtieneHistorialCierres", JSON.stringify({
      fechaIni: fechaIni || null,
      fechaFin: fechaFin || null,
      idCajero: idCajero || null
    })).then(data => {
      let { result, error } = ValidationResponse(data);
      if (!error) setHistorialCierres(result || []);
    });
  };

  return {
    getInicioCaja,
    getConsultaCajaXDia,
    cierreCaja,
    getGeneraCierreCaja,
    iniciaCajaRes,
    cajasVencidas,
    getCajasVencidas,
    cajaActual,
    getEstadoCaja,
    historialCierres,
    getHistorialCierres,
  };
};

export default useControlCaja;
